/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AIDetection, AIDetection$inboundSchema } from "./aidetection.js";
import {
  AIDetectionUser,
  AIDetectionUser$inboundSchema,
} from "./aidetectionuser.js";

export type ListAIDetectionUsersResult = {
  /**
   * One AI detection target aggregated across an organization's device-agent scan reports.
   */
  detection: AIDetection;
  /**
   * Users the target was detected for, most recently seen first.
   */
  users: Array<AIDetectionUser>;
};

/** @internal */
export const ListAIDetectionUsersResult$inboundSchema: z.ZodMiniType<
  ListAIDetectionUsersResult,
  unknown
> = z.object({
  detection: AIDetection$inboundSchema,
  users: z.array(AIDetectionUser$inboundSchema),
});

export function listAIDetectionUsersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListAIDetectionUsersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListAIDetectionUsersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListAIDetectionUsersResult' from JSON`,
  );
}
